'use client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { customerJWT } from '@repo/customer-api';
import { theme } from '@repo/ui';
import { formatter, getClientCookie, parseJwt, SendNavigatorData } from '@repo/utils';
import { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { CustomerModal } from '../components/modal';
import { CustomerToast } from '../components/toast';
import { store } from './store';
import { pushUserdata } from './userdataSlice';

const LoadUserData = () => {
  const dispatch = useDispatch();
  const token = getClientCookie('token-customer');
  const decodedToken = parseJwt(token || '') as customerJWT;
  useEffect(() => {
    if (decodedToken) {
      dispatch(
        pushUserdata({
          username: formatter(decodedToken.fullName, 'capitalize').replaceAll(',', ' '),
          userId: `${decodedToken.userId}`,
        }),
      );
    }
  }, [dispatch, decodedToken]);
  return <></>;
};

export function Providers({ children, nonce }: { children: React.ReactNode; nonce: string }) {
  useEffect(() => {
    SendNavigatorData({
      app: 'customer',
    });
  }, []);
  return (
    <ThemeProvider theme={theme({ nonce })}>
      <CssBaseline />
      <Provider store={store}>
        <LoadUserData />
        <CustomerModal />
        <CustomerToast />
        {children}
      </Provider>
    </ThemeProvider>
  );
}
